<script>
export default {
  name: 'DescriptionListEntry',

  functional: true,

  props: {
    name: {
      type: [Number, String],
      required: false,
      default: null,
    },

    value: {
      type: [Number, String],
      required: false,
      default: null,
    },

    data: {
      type: [Array, Object],
      required: false,
      default: null,
    },

    field: {
      type: [Boolean, String],
      required: false,
      default: null,
    },

    default: {
      type: String,
      required: false,
      default: '',
    },

    mandatory: {
      type: Boolean,
      required: false,
    },

    separator: {
      type: String,
      required: false,
      default: '.',
    },

    boolean: {
      type: Boolean,
      required: false,
    },

    true: {
      type: String,
      required: false,
      default: 'common.yes',
    },

    false: {
      type: String,
      required: false,
      default: 'common.no',
    },

    nameField: {
      type: String,
      required: false,
      default: null,
    },
  },

  render: (h, ctx) => {
    const {
      name,
      value,
      data,
      field,
      mandatory,
      default: defaultValue,
      separator,
      boolean: booleanFlag,
      true: trueValue,
      false: falseValue,
      nameField,
    } = ctx.props;

    const parse = v => {
      let r = null;
      try {
        r = v
          .replace('[', separator)
          .replace(']', '')
          .split(separator)
          .reduce((obj, property) => obj[property], data);
      } catch (err) {}
      return r;
    };

    let ddValue = defaultValue;
    if (value) ddValue = value;
    else {
      const parsedValue = parse(field);

      if (!field || !data || parsedValue === undefined || parsedValue === null || parsedValue === '') {
        // if there is no value to be shown
        if (!mandatory && !ddValue) {
          // and the mandatory flag is not set (= optional)
          if ((field !== null && (field !== true || !data)) || !ctx.scopedSlots.default) return; // if a field is set or slot is empty (or empty field is set and data is empty)
        }
      } else {
        ddValue = parsedValue;
      }
    }

    if (ctx.scopedSlots.default) {
      ddValue = ctx.scopedSlots.default({ value: ddValue, data });
      if (!mandatory && (!ddValue || (Array.isArray(ddValue) && ddValue.length === 1 && !ddValue[0].tag && !ddValue[0].children && !ddValue[0].text?.trim())))
        // optional and slot is empty (or only spaces)
        return;
    }

    if (ctx.scopedSlots.override) {
      return ctx.scopedSlots.override({ value: ddValue });
    }

    if (booleanFlag) {
      ddValue = ddValue ? trueValue : falseValue;
    }

    let dt;
    if (ctx.scopedSlots.name) {
      dt = h(
        'dt',
        ctx.scopedSlots.name({
          value: ddValue,
          name: parse(nameField),
        })
      );
    } else {
      dt = h('dt', { domProps: { innerHTML: ctx.parent.$to(name) } });
    }

    let dd;
    if (ctx.scopedSlots.value) {
      dd = h(
        'dd',
        ctx.scopedSlots.value({
          value: ddValue,
          name: parse(nameField),
        })
      );
    } else {
      if (booleanFlag) {
        ddValue = { domProps: { innerHTML: ctx.parent.$to(ddValue) } };
      }

      dd = h('dd', ddValue);
    }

    return [dt, dd];
  },
};
</script>
